import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Slider } from "./shadcn/slider";

/**
 * Sometimes, when form is submitted (server action), the input values are reset.
 * This component keeps a copy of the input value in the component state to prevent this.
 * Honestly speaking, I don't know why this happens. Didn't want to waste time debugging it.
 * When we fix the issue, we can remove this component. - Michał
 */
export const StatefulSlider = t0 => {
  const $ = _c(16);
  let defaultValue;
  let onValueChange;
  let props;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      onValueChange,
      defaultValue,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = defaultValue;
    $[2] = onValueChange;
    $[3] = props;
    $[4] = value;
  } else {
    defaultValue = $[1];
    onValueChange = $[2];
    props = $[3];
    value = $[4];
  }
  const [state, setState] = useState(value || defaultValue);
  let t1;
  if ($[5] !== onValueChange) {
    t1 = value_0 => {
      setState(value_0);
      onValueChange?.(value_0);
    };
    $[5] = onValueChange;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== props || $[8] !== state || $[9] !== t1) {
    t2 = <Slider {...props} value={state} onValueChange={t1} />;
    $[7] = props;
    $[8] = state;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== state) {
    t3 = <span>{state}</span>;
    $[11] = state;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t2 || $[14] !== t3) {
    t4 = <div className="flex items-center gap-x-2">{t2}{t3}</div>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};